const RENTER_LEASE_TERM_OPTION_TERSE = '6 months or less';
const RENTER_LEASE_TERM_OPTION_SHORT = '7 to 11 months';
const RENTER_LEASE_TERM_OPTION_STANDARD = '1 year';
const RENTER_LEASE_TERM_OPTION_LONG = 'More than 1 year';

const leaseTermOptionItems = [
  {
    label: '6 months or less',
    value: RENTER_LEASE_TERM_OPTION_TERSE,
  },
  {
    label: '7 to 11 months',
    value: RENTER_LEASE_TERM_OPTION_SHORT,
  },
  {
    label: '12 months',
    value: RENTER_LEASE_TERM_OPTION_STANDARD,
  },
  {
    label: 'More than 1 year',
    value: RENTER_LEASE_TERM_OPTION_LONG,
  },
];

export default leaseTermOptionItems;
